module.exports = "<ion-view view-title=\"Notifiche\">\n\n\n  <ion-content>\n\n    <ion-list>\n      <ion-item\n        class=\"item-text-wrap\"\n        collection-repeat=\"obj in NotificationsCtrl.objects track by $index\">\n        {{ obj.message }}\n        <ion-option-button class=\"button-assertive\" ng-click=\"NotificationsCtrl.confirmDropNotification(obj, $index)\">Elimina</ion-option-button>\n      </ion-item>\n    </ion-list>\n\n  </ion-content>\n\n</ion-view>\n"


//////////////////
// WEBPACK FOOTER
// ./www/templates/notifications.html
// module id = 29
// module chunks = 0